import {
    Component,
    Input,
    Output,
    ElementRef,
    EventEmitter
} from '@angular/core';

import {EventsService} from "../services/events.service";
import {Logger} from "../utils/logger";

@Component({
    selector: 'filter-tab',
    templateUrl: "./filter_tab.component.html"
})

export class FilterTabComponent {
    @Input("group")
    public productGroup;

    @Input()
    public tabName; // filter name

    @Input()
    public tabIndex;

    @Output('onFilterTabChanged')
    public filterTabChanged: EventEmitter<any>;

    @Output('onAllItemsChecked')
    public allItemsChecked: EventEmitter<any>;

    constructor(public el: ElementRef, public eventBus: EventsService, public logger: Logger) {
        this.filterTabChanged = new EventEmitter<any>();
        this.allItemsChecked = new EventEmitter<any>();
    }

    onFilterTabChanged(event: Event, tabId: number, tabName: string) {
        this.filterTabChanged.emit({tabId: tabId, tabName: tabName});
    }

    checkAllItems(tabIndex: number) {
        this.allItemsChecked.emit({tabIndex: tabIndex});
    }
}


// WEBPACK FOOTER //
// ./src/app/filter_panel/filter_tab.component.ts